module.exports = __webpack_public_path__ + "static/media/arrow-button.cfe164df.svg";